import React from 'react';

const TermsModalContent = () => {
  return (
    <div className="bg-white rounded-lg p-6 space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Términos y Condiciones</h2>
        <p className="text-gray-700 leading-relaxed">Última actualización: Enero 2026</p>
      </div>

      <section>
        <h3 className="text-lg font-semibold mb-2">1. Aceptación de los Términos</h3>
        <p className="text-gray-700 leading-relaxed">
          Al acceder y utilizar TuClinicApp, usted acepta estar sujeto a estos Términos y Condiciones de uso. Si no está de acuerdo con alguno de estos términos, le recomendamos no utilizar nuestro servicio.
        </p>
      </section>

      <section>
        <h3 className="text-lg font-semibold mb-2">2. Descripción del Servicio</h3>
        <p className="text-gray-700 leading-relaxed">TuClinicApp es una plataforma de directorio de clínicas dentales que permite a los usuarios buscar, comparar y contactar clínicas.</p>
      </section>

      <section>
        <h3 className="text-lg font-semibold mb-2">3. Registro de Clínicas</h3>
        <p className="text-gray-700 leading-relaxed">Las clínicas deben proporcionar información veraz. Nos reservamos el derecho de verificar y aprobar los registros.</p>
      </section>

      <section>
        <h3 className="text-lg font-semibold mb-2">4. Privacidad y Datos Personales</h3>
        <p className="text-gray-700 leading-relaxed">Respetamos su privacidad y protegemos sus datos personales de acuerdo con las leyes aplicables. La información recopilada se utiliza para mejorar nuestros servicios y facilitar la comunicación entre usuarios y clínicas.</p>
      </section>

      <div className="text-sm text-gray-500">
        <p>Al aceptar, usted reconoce haber leído, entendido y aceptado estos Términos y Condiciones.</p>
      </div>
    </div>
  );
};

export default TermsModalContent;
